import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { RoutingProvider, createRoutingStrategy } from '@rad/hooks';
import { configurePathToURL } from './common/routes';
import { configureCommunityRequests } from './common/community-path';
import AppContent from './AppContent';
const routingStrategy = createRoutingStrategy(__ROUTING_BASENAME__);
configurePathToURL(routingStrategy);
configureCommunityRequests();
const AppCommon = (props) => {
    return _jsx(_Fragment, { children: _jsx(RoutingProvider, { strategy: routingStrategy, children: props.wrapper(_jsx(AppContent, { routingConfig: props.routingConfig })) }) });
};
export default AppCommon;
